import { useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useLang } from "@/i18n";
import { extra } from "@/content-extra";

export default function Faq() {
  const { lang } = useLang();
  const faq = extra[lang].faq;
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-24 sm:py-32 border-b border-white/10" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6">
        <motion.p initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="overline-tag" data-testid="faq-overline">
          {faq.overline}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}
          className="mt-4 font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl"
        >
          {faq.h2}
        </motion.h2>
        <div className="mt-12 space-y-3">
          {faq.items.map((item, i) => (
            <motion.div
              key={item.q}
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
              className="glass rounded-2xl overflow-hidden" data-testid={`faq-item-${i}`}
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
                aria-expanded={open === i}
                data-testid={`faq-toggle-${i}`}
              >
                <span className="font-display font-semibold text-base sm:text-lg">{item.q}</span>
                <ChevronDown size={18} className={`text-volt shrink-0 transition-transform duration-300 ${open === i ? "rotate-180" : ""}`} />
              </button>
              <div className={`grid transition-[grid-template-rows] duration-300 ${open === i ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                <div className="overflow-hidden">
                  <p className="px-6 pb-5 text-sm text-steel leading-relaxed">{item.a}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
